module.exports = __webpack_public_path__ + "static/img/15.a827578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/15.jpg
// module id = aig0
// module chunks = 1